import React from 'react';
import IfCanAccess from 'src/components/widgets/ifCanAccess/ifCanAccess';
import ConnectCatalog from './connectCatalog';

export default function ConnectCatalogIndex() {
    return (
        <IfCanAccess permission='PRODUCTS_EDIT'>
            <ConnectCatalog />
        </IfCanAccess>
    );
}
